var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['AppBackground--scoped'],style:({'background-color': _vm.config[_vm.AppThemeSetting].appAllUnits.appBackgroundColor,
     'width': this.windowWidth + 'px'
      })})}
var staticRenderFns = []

export { render, staticRenderFns }